import React from "react";

const DisclaimerContentWrapper = ({
  mainDisclaimerDataContent,
  mainDisclaimerHeaderContent,
}) => {
  const showDisclaimerItemData = (item, ind) => {
    if (item.type === "para") {
      return (
        <div key={ind} className="mb-3">
          <div className="disclaimer-sub-head">{item?.dataHeader}</div>
          {item?.content.length > 0 &&
            item?.content.map((val, i) => <p key={i}>{val}</p>)}
        </div>
      );
    } else {
      return null;
    }
  };
  return (
    <div className="disclaimer-content-wrapper">
      <div>
        {mainDisclaimerHeaderContent && mainDisclaimerHeaderContent.header && (
          <h1 className="disclaimer-head mb-0">
            {mainDisclaimerHeaderContent.header}
          </h1>
        )}
        {mainDisclaimerHeaderContent &&
          mainDisclaimerHeaderContent.lastUpdated && (
            <div className="disclaimer-last-updated mb-3">
              {mainDisclaimerHeaderContent.lastUpdated}
            </div>
          )}
        {mainDisclaimerHeaderContent &&
          mainDisclaimerHeaderContent.disclaimerIntro && (
            <p className="mb-3">
              {mainDisclaimerHeaderContent.disclaimerIntro}
            </p>
          )}
        {mainDisclaimerDataContent.length > 0 &&
          mainDisclaimerDataContent.map((item, i) =>
            showDisclaimerItemData(item, i)
          )}
      </div>
    </div>
  );
};

export default DisclaimerContentWrapper;
